import React from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";

/** Admin — Office Records → Schedules */
export default function AdminDashboardCards({ loading, dashboardStats }) {
  const stats = dashboardStats || {
    total_schedules: 0,
    upcoming_schedules: 0,
    completed_schedules: 0,
    cancelled_schedules: 0,
    today_schedules: 0,
  };

  const metricItems = [
    {
      key: "total_schedules",
      label: "Total Schedules",
      value: stats.total_schedules ?? 0,
      tone: "slate",
      chartHeights: [0.42, 0.58, 0.48, 0.62, 0.72],
    },
    {
      key: "upcoming_schedules",
      label: "Upcoming Schedules",
      value: stats.upcoming_schedules ?? 0,
      tone: "teal",
      chartHeights: [0.38, 0.52, 0.65, 0.55, 0.7],
    },
    {
      key: "completed_schedules",
      label: "Completed Schedules",
      value: stats.completed_schedules ?? 0,
      tone: "mint",
      chartHeights: [0.55, 0.62, 0.58, 0.7, 0.78],
    },
    {
      key: "cancelled_schedules",
      label: "Cancelled Schedules",
      value: stats.cancelled_schedules ?? 0,
      tone: "slate",
      chartHeights: [0.4, 0.5, 0.55, 0.6, 0.65],
    },
    {
      key: "today_schedules",
      label: "Today's Schedules",
      value: stats.today_schedules ?? 0,
      tone: "teal",
      chartHeights: [0.38, 0.52, 0.65, 0.55, 0.7],
    },
  ];

  return (
    <GlobalMetricCards
      items={metricItems}
      loading={loading}
      skeletonCount={5}
      ariaLabel="Schedule statistics"
    />
  );
}
